export const maskPhone = (value: string): string => {
  let digits = value.replace(/\D/g, '');
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  digits = digits.slice(0, 11);
  if (digits.length < 2) return digits;
  const area = '(' + digits.slice(0, 2) + ')';
  const local = digits.slice(2);
  if (!local) return area;
  const split = local.length > 8 ? 5 : 4;
  return area + ' ' + local.slice(0, split) + (local.length > split ? '-' + local.slice(split) : '');
};
